export enum DocumentLevel {
  NA = 'NA',
  MBO1 = 'MBO1',
  MBO2 = 'MBO2',
  MBO3 = 'MBO3',
  MBO4 = 'MBO4',
  HBO = 'HBO',
  WO = 'WO',
}
